/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedHeadMetaTags_metadata = {
    readonly title: string | null;
    readonly description: string | null;
    readonly canonical: string | null;
    readonly disableIndexing: boolean | null;
    readonly " $refType": "SharedHeadMetaTags_metadata";
};
export type SharedHeadMetaTags_metadata$data = SharedHeadMetaTags_metadata;
export type SharedHeadMetaTags_metadata$key = {
    readonly " $data"?: SharedHeadMetaTags_metadata$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedHeadMetaTags_metadata">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedHeadMetaTags_metadata",
  "type": "MetaData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canonical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "disableIndexing",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'ca76300d3b6c58791ea89756c863589a';
export default node;
